import { useMutation } from '@tanstack/react-query';
import { updateOrder } from 'utils/OrderWebAPIUtils';
import OrdersActionCreators from 'actions/OrdersActionCreators';
export function useUpdateAccountingReviewDate() {
    return useMutation({
        mutationFn: async ({ orderId, accountingReviewDate }) => {
            const res = await updateOrder(orderId, {
                accounting_review_date: accountingReviewDate,
            });
            return res.entity.order;
        },
        onSuccess: (_data, { orderId }) => {
            OrdersActionCreators.getOrder(orderId);
        },
    });
}
